import dayjs from "dayjs";

export const getToday = (format = "YYYY/MM/DD") => {
  return dayjs().format(format);
};

export const formatDate = (
  date: string | number | Date,
  format = "YYYY/MM/DD"
) => {
  return dayjs(date).format(format);
};

// 現在日時を指定したフォーマットで取得
export const getNow = (format = "YYYY/MM/DD HH:mm:ss") => {
  return dayjs().format(format);
};
